"use client"

import { Button, Col, Row } from "antd"
import TourCard from "../TourCard"
import Title from "@/components/common/Typography/Title"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import Carousel from "@/components/common/Carousel"
import { FC } from "react"
import { TypeTourCollection } from "@/lib/redux/features/tour/types"
import Text from "@/components/common/Typography/Text"
import { useTERouter } from "@/hooks/app/useTERouter"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons"
import { useTranslation } from "react-i18next"
import Link from "@/components/common/LinkNext"

type ToursCollectionProps = {
  collection: TypeTourCollection
}

const ToursCollection = ({ collection }: ToursCollectionProps) => {
  const isDesktop = useIsDesktop()
  const router = useTERouter()
  const { t } = useTranslation()

  return (
    <>
      <Row justify={'space-between'} align='middle'>
        <Col>
          <Row>
            <Title level={3} style={{ marginBottom: 0 }}>
              {collection.title}
            </Title>
          </Row>
          <Row style={{ marginBottom: '1rem' }}>
            <Text type='secondary'>
              {collection?.description}
            </Text>
          </Row>
        </Col>
        <Col>
          {!isDesktop && !!collection?.categoryIds[0] && (
            <Link
              href={`/tours/category/${collection?.categoryIds[0]}`}
            >
              <Button
                size='large'
                type='primary'
                shape='circle'
                icon={<FontAwesomeIcon icon={faChevronRight} />}
                onClick={() => router.push(`/tours/category/${collection?.categoryIds[0]}`)}
              />
            </Link>
          )}
        </Col>
      </Row>
      {isDesktop ? (
        <Row gutter={[10, 10]}>
          {collection.tourData
            .slice(0, 6)
            .filter(tour => !!tour)
            .map((tour, index) => {
              return (
                <Col key={tour.id ?? tour.tourId ?? index} span={8}>
                  <TourCard tour={tour} />
                </Col>
              )
            })}
          {!!collection.categoryIds[0] && (<Col span={24}>
            <Row justify='center'>
              <Link
                href={`/tours/category/${collection?.categoryIds[0]}`}
              >
                <Button
                  type='primary'
                  size='large'
                  onClick={() => router.push(`/tours/category/${collection.categoryIds[0]}`)}
                >
                  {t("common.see_more")}
                </Button>
              </Link>
            </Row>
          </Col>)}
        </Row>
      ) : (
        <Carousel
          className="carousel-main"
          options={{
            pageDots: false,
            cellAlign: "left",
            draggable: true,
            prevNextButtons: false,
            contain: true
          }}
        >
          {collection.tourData
            .filter(tour => !!tour)
            .slice(0, 6)
            .map((tour, index) => {
              return (
                <div
                  key={tour.id ?? tour.tourId ?? index}
                  style={{ maxWidth: '80%', paddingRight: '1rem' }}
                >
                  <TourCard tour={tour} />
                </div>
              )
            })}
        </Carousel>
      )}
    </>
  )
}

export default ToursCollection